import React from 'react';

import Links from 'web/components/common/modal/common/Links';
import * as input from 'web/components/common/modal/common/input';
import BackBtn from 'web/components/common/modal/common/BackBtn';
import CloseBtn from 'web/components/common/modal/common/CloseBtn';

import classNames from 'classnames/bind';
import styles from './DuplicateData.scss';
const cx = classNames.bind(styles);

const DuplicateData = ({
  guide = '',
  email = '',
  buttons = [],
  links = [],
  finalButton = {},

  handleBack,
  handleClose,
}) => {
  return (
    <div
      className={cx('DuplicateData', 'vertify-phone')}
      onClick={e => e.stopPropagation()}
    >
      {/* 이미 연동된 계정이 있습니다. */}
      {guide ? <pre className="guide">{guide}</pre> : null}
      {email ? <div className="email">{email}</div> : null}
      {buttons.length ? (
        <div className="buttons">
          {buttons.map((button, i) => {
            const { idx = i, name = '', type = 'button', onClick } = button;
            return (
              <input.Button
                key={`DuplicateData-buttons-${idx}`}
                type={type}
                onClick={onClick}
              >
                {name}
              </input.Button>
            );
          })}
        </div>
      ) : null}

      {links.length ? (
        <Links links={links} style={{ textAlign: 'center' }} />
      ) : null}

      {finalButton.name ? (
        <input.BottomButton msg={finalButton.msg} onClick={finalButton.onClick}>
          {finalButton.name}
        </input.BottomButton>
      ) : null}
      {typeof handleBack === 'function' ? (
        <BackBtn className={['btn-back']} onClick={handleBack} />
      ) : null}
      {typeof handleClose === 'function' ? (
        <CloseBtn onClick={handleClose} className={['btn-close']} />
      ) : null}
    </div>
  );
};

export default DuplicateData;
